import axios from "axios";
import { ACTION_TYPES } from "./types";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import axiosInstance from "../../services/api";

axios.defaults.baseURL = "https://cx.api.averly.com.na";

export const updateAppStatus = (payload) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.UPDATE_APP_STATUS,
    payload,
  });
};

export const verifyToken = () => async (dispatch) => {
  // log cookies with pure js
  dispatch({ type: ACTION_TYPES.SET_AUTH_LOADING, payload: true });
  const userId = Cookies.get("userId");

  try {
    const res = await axiosInstance.get(`/auth/verification?userId=${userId}`);
    dispatch({ type: ACTION_TYPES.SET_USER_DATA, payload: res.data.user });
    dispatch({
      type: ACTION_TYPES.GET_USER_PERMISSIONS,
      payload: res.data.permissions,
    });
    // v2 RBAC — effective permissions and roles from /auth/verification
    dispatch({
      type: ACTION_TYPES.SET_EFFECTIVE_PERMISSIONS,
      payload: res.data.effectivePermissions || [],
    });
    dispatch({
      type: ACTION_TYPES.SET_USER_ROLES,
      payload: res.data.roles || [],
    });
    dispatch({
      type: ACTION_TYPES.SET_USER_ID,
      payload: Cookies.get("userId"),
    });

    dispatch({
      type: ACTION_TYPES.UPDATE_VERIFY_STATUS,
      payload: 1,
    });
  } catch (err) {
    dispatch({
      type: ACTION_TYPES.UPDATE_VERIFY_STATUS,
      payload: 0,
    });

    window.location.replace(
      `${process.env.REACT_APP_AUTH_AVERLY_WEBSITE}?origin=${window.location.href}`
    );
  }
  dispatch({ type: ACTION_TYPES.SET_AUTH_LOADING, payload: false });
};
